import moment from 'moment';

export const parseAmountDecimal = (amtVal) => {
  let strVal = amtVal.toString();
  let finalVal = strVal;
  const decimalIdx = strVal.indexOf(".");
  if (decimalIdx < 0) {
    finalVal = strVal + '.00';
  } else {
    const decimalLen = strVal.substr(decimalIdx + 1).length;
    if (decimalLen < 2) {
      finalVal = strVal + '0';
    }
  }

  return finalVal;
};

export const initReducer = (oldProps, newProps) => ({ ...oldProps, ...newProps });

export const checkStartEnd = (startTime, endTime) => {
  console.log("INCOMING TIME: ", startTime, endTime);
  const start = moment(startTime, 'HH:mm');
  const end = moment(endTime, 'HH:mm');

  return start.isSameOrAfter(end) ? false : true;
};
